import React, { SVGProps } from 'react'

/**
 * The identity lockup's leading card glyph (Figma 51:179, "card glyph"). Figma
 * exports it once per status with the stroke baked to that state's tag text
 * colour; the single path here takes `currentColor` instead, so one icon serves
 * every state and inherits the lockup's tint.
 *
 * Feature-local for the same reason as the sibling glyphs: `gen-svg-components`
 * wipes and regenerates src/components/Svgs from src/assets/svgs, and this has
 * no source asset.
 */
const SvgCard = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.05}
      d="M11.625 3.5625H3.375C2.54657 3.5625 1.875 4.23407 1.875 5.0625V9.9375C1.875 10.7659 2.54657 11.4375 3.375 11.4375H11.625C12.4534 11.4375 13.125 10.7659 13.125 9.9375V5.0625C13.125 4.23407 12.4534 3.5625 11.625 3.5625Z"
    />
    <path
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.05}
      d="M1.875 6.45H13.125"
    />
  </svg>
)
export default SvgCard
